<script>
  import PublicContentPage from './PublicContentPage.svelte';
  import HomeDiscovery from '../HomePages/HomeDiscovery.svelte';
  export let navigateTo;
</script>

<PublicContentPage />
<div class="home-discovery"><HomeDiscovery {navigateTo} /></div>

<style>
  .home-discovery { max-width: 1064px; margin: auto; padding: 0 28px; }
</style>
